import { resolveUniqueAssemblyOfflinePackageFile } from '@puppycad/cad-core'
import type { CadNode, FileInfo } from '@puppycad/proto'

/**
 * 解析装配节点可用于替代 children 的离线包文件。
 *
 * 设计说明：同一个装配节点最多只能有一个 `.puppy` 离线包；出现多个说明后端
 * CadNode 快照不可信，前端不能排序或静默选择，否则会让装配还原结果不可预测。
 *
 * @param cadNode 后端返回的 CAD 装配节点。
 * @returns 唯一离线包文件；没有 `.puppy` 时返回 undefined。
 */
export function resolveAssemblyOfflinePackageFile(cadNode: CadNode): FileInfo | undefined {
  return resolveUniqueAssemblyOfflinePackageFile({
    files: cadNode.files,
    repositoryId: cadNode.repositoryId.toString(),
    commitId: cadNode.commitId,
  })
}
